// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"b4608035","28":"69f18304","241":"a8c55fd2","371":"2323b068","529":"b0bb59ee","684":"8247b12d"}[chunkId] + ".css";
};